import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { OrderWizardService } from '../../_service/order-wizard.service'
import { CorpCardComponent } from '@corporate-tailwind/component'
import { OrderPurchaseSummaryAlertComponent } from './purchase-summary-alert/order-purchase-summary-alert.component'
import { OrderPurchaseSummaryTableComponent } from './purchase-summary-table/order-purchase-summary-table.component'

@Component({
    selector: 'order-purchase-summary',
    imports: [CommonModule, ReactiveFormsModule, CorpCardComponent, TranslateModule, OrderPurchaseSummaryTableComponent, OrderPurchaseSummaryAlertComponent],
    templateUrl: './order-purchase-summary.component.html',
    styleUrls: ['./order-purchase-summary.component.scss']
})
export class OrderPurchaseSummaryComponent implements OnInit, OnDestroy {
@Input() showAlert: boolean = false;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
;
    }

    ngOnInit(): void {
        
    }

    ngOnDestroy(): void {
  
    }


}
